var isPrototypeOf = require('../../internals/object-is-prototype-of');
var method = require('../array/virtual/flat');

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.flat;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.flat) ? method : own;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/instance/flat.js
// module id = 3392
// module chunks = 25